import axios from 'axios';
import router from "../../router";

const state = {
    //club data
    clubData: [],

    //shipment data
    shipmentCountry: 'NZ',
    currency: 'NZD',
    availableShipments: [],
    catalogs: [],
    cheeseCatalogs: [],
    selections: [],
    discounts: null,
    shipments: [],
    minAllowedShipments: 4,

    //member data
    memberID: null,
    memberFirstName: '',
    memberSurname: '',
    memberCountry: null,
    existingPreference: null,
    memberTier: null,
    memberStatus: null,
    nextShipmentDate: null,
    isCustomSelection: false,
    orderHistory: [],

    //working state
    configStep: 0,
    activeCatalog: null,
    activeCheeseAddon: null,
    shipmentWines: [{}, {}, {}],
    shipmentMinimum: 3,
    originalPrice: 0.00,
    discountedPrice: 0.00,
    eligibleDiscount: 0,
    savings: 0.00,

    //error messages
    preferenceErrorMessage: null,

    //rendering states
    isLoggedIn: false,
    isClubMember: false,
    hasPreference: false,
    isNextShipmentOpen: false,
    shippingAddressID: null,
    shippingAddress: null,
    savedCardID: null,
};

const getters = {
    getShipmentCountry: () => state.shipmentCountry,
    getAvailableShipments: () => state.availableShipments,
    getCatalogs: () => state.catalogs,
    getCheeseCatalogs: () => state.cheeseCatalogs,
    getSelections: () => state.selections,
    getShipments: () => state.shipments,
    getMemberID: () => state.memberID,
    getMemberFirstName: () => state.memberFirstName,
    getMemberSurname: () => state.memberSurname,
    getMemberCountry: () => state.memberCountry,
    getExistingPreference: () => state.existingPreference,
    getMemberStatus: () => state.memberStatus,
    getMemberTier: () => state.memberTier,
    getNextShipmentDate: () => state.nextShipmentDate,
    getConfigStep: () => state.configStep,
    getIsCustomSelection: () => state.isCustomSelection,
    getActiveCatalog: () => state.activeCatalog,
    getActiveCheeseAddon: () => state.activeCheeseAddon,
    getShipmentWines: () => state.shipmentWines,
    getShipmentMinimum: () => state.shipmentMinimum,
    getOriginalPrice: () => state.originalPrice,
    getDiscountedPrice: () => state.discountedPrice,
    getEligibleDiscount: () => state.eligibleDiscount,
    getSavings: () => state.savings,
    getIsLoggedIn: () => state.isLoggedIn,
    getIsClubMember: () => state.isClubMember,
    getHasPreference: () => state.hasPreference,
    getIsNextShipmentOpen: () => state.isNextShipmentOpen,
    getShippingAddress: () => state.shippingAddress,
    getShippingAddressID: () => state.shippingAddressID,
    getSavedCardID: () => state.savedCardID,
    getPreferenceErrorMessage: () => state.preferenceErrorMessage,
    getMinAllowedShipments: () => state.minAllowedShipments,
    getOrderHistory: () => state.orderHistory,
    getCurrency: () => state.currency,

};

const actions = {
    goToUpdateDetails() {
        const { origin } = window.location;
        window.location.href = `${origin}/shop/member`;
    },
    goToUpdateBilling() {
        const { origin } = window.location;
        window.location.href = `${origin}/shop/billing?builder=1`;
    },
    /**
     * fetch order history for member
     */
    async fetchOrderHistory({dispatch, commit}) {
        const response = await axios.get(window.location.origin + '/account/history');
        if (typeof response.data !== 'undefined') {
            if (response.data.Orders) {
                commit('updateOrderHistory', response.data.Orders);
            }
        }
    },

    /**
     * store the club data for easy access
     * @param commit
     * @param data
     */
    initialiseClubs({commit}, data) {
        commit('updateClubData', data);
    },

    /**
     * change country and all associated data
     * @param dispatch
     * @param commit
     * @param country
     */
    changeCountry({dispatch, commit}, country) {
        let clubData = state.clubData,
            countryCode = typeof country === 'object' ? country.value.toString().toUpperCase() : country.toString().toUpperCase(),
            countryCheck = countryCode,
            countryData = clubData[countryCode];

        if (typeof countryData === 'undefined') {
            countryCode = 'NZ';
            countryData = clubData[countryCode];
        }

        if (countryData) {
            commit('updateShipmentCountry', countryCode);

            let shipmentsCount = countryData.Schedules.length;
            if (state.memberTier && countryCheck !== countryCode) {
                //international members cannot split their order to below 12 bottles.
                let annuallyBottles = state.memberTier.AnnuallyBottles,
                    minBottlesPerShipment = 12;

                if (annuallyBottles > 0) {
                    shipmentsCount = annuallyBottles / minBottlesPerShipment;
                }
            }

            commit('updateMinAllowedShipments', shipmentsCount);
            commit('updateCountryData', countryData)
            // commit('updateAvailableShipments', countryData.Schedules);
            // commit('updateCatalogs', countryData.Catalogs);
            // commit('updateCheeseCatalogs', countryData.CheeseCatalogs);
            // commit('updateSelections', countryData.Selections);
            // commit('updateDiscounts', countryData.Discounts);
            // commit('updateCurrency', countryData.Currency);
        }
    },

    /**
     * initialise member
     * @param dispatch
     * @param commit
     * @param data
     */
    initialiseMember({dispatch, commit}, data) {
        commit('updateMemberData', data);
        // commit('updateMemberID', data['MemberID']);
        // commit('updateMemberFirstName', data['MemberFirstName']);
        // commit('updateMemberSurname', data['MemberSurname']);
        // commit('updateMemberCountry', data['MemberCountry']);
        // commit('updateNextShipmentDate', data['NextShipment']);
        // commit('updateMemberTier', data['MemberTier']);
        // commit('updateIsClubMember', data['IsClubMember']);
        // commit('updateIsNextShipmentOpen', data['ShipmentOpen']);
        // commit('updateIsLoggedIn', true);

        // commit('updateShippingAddressID', data['ShippingAddressID']);
        // commit('updateShippingAddress', data['ShippingAddress']);
        // commit('updateSavedCardID', data['SavedCardID']);

        // if (data['ShipmentCountry'] !== state.shipmentCountry) {
        let country = data['ShipmentCountry'] ? data['ShipmentCountry'] : 'NZ'
        dispatch('changeCountry', country)
        // }

        dispatch('setPreference', data['Preference']);
        dispatch('changeShipmentSettings');
    },

    /**
     * load member's preference
     * @param dispatch
     * @param commit
     * @param preference
     */
    setPreference({dispatch, commit}, preference) {
        if (preference) {
            let shipmentCountry = preference.WineClub.ShipmentCountry,
                memberTier = preference.MemberTier,
                shipments = preference.Shipments,
                catalog = preference.Catalog,
                cheeseCatalog = preference.CheeseCatalog;

            // load shipments
            if (shipments && shipments.length) {
                commit('updateShipments', shipments);
            }

            // only use preference if it is consistent with the user's membership
            // THIS CODE WILL NEVER RUN BECUASE state.ShipmentCountry is NEVER set!!!!
            // if (shipmentCountry === state.ShipmentCountry && memberTier.ID === state.memberTier.ID) {

            //     commit('updateExistingPreference', preference);

            //     if (catalog.ID > 0) {
            //         let wines = catalog.wines;
            //         if (wines && wines.length) {
            //             dispatch('useCatalogWine', catalog);
            //         } else {
            //             // dispatch('usePreferenceWine', preference);
            //         }
            //     } else {
            //         // dispatch('usePreferenceWine', preference);
            //     }

            //     // if (cheeseCatalog.ID > 0) {
            //     //     commit('updateActiveCheeseAddon', cheeseCatalog);
            //     // }
            // }

            commit('updateHasPreference', true);
        }
    },

    /**
     * sets the current step which the user is on when building the shipment
     * @param commit
     * @param step
     */
    setConfigStep({commit}, step) {
        commit('updateConfigStep', step);
        let module = document.getElementById('shipment-builder-module');
        module.scrollIntoView(true);
    },

    /**
     * sets a flag for custom selection
     * @param commit
     * @param flag
     */
    setIsCustomSelection({commit}, flag) {
        commit('updateIsCustomSelection', flag);
    },

    /**
     * change selected member tier
     * @param dispatch
     * @param commit
     * @param tier
     */
    changeMemberTier({dispatch, commit}, tier) {
        // console.log(tier)
        // console.log(state.shipmentMinimum)
        commit('updateMemberTier', tier);

        //country needs to be reset if the tier change because the shipments options need to be reset, international members have a minimum shipment bottle limit.
        // dispatch('changeCountry', 'NZ');

        dispatch('changeShipmentSettings');
    },

    /**
     * toggle selected shipments
     * @param dispatch
     * @param commit
     * @param shipment
     */
    toggleShipments({dispatch, commit}, shipment) {
        let selectedShipments = state.shipments,
            selected = selectedShipments.filter(item => {
                return item.ID === shipment.ID
            });

        if (selected.length) {
            selectedShipments = selectedShipments.filter(item => {
                return item.ID !== shipment.ID
            });
        } else {
            selectedShipments.push(shipment);
        }
        commit('updateShipments', selectedShipments);
        dispatch('changeShipmentSettings');
    },

    /**
     * change selected shipments
     * @param dispatch
     * @param commit
     * @param shipment
     */
    changeShipments({dispatch, commit}, shipment) {
        commit('updateShipments', [shipment]);
        dispatch('changeShipmentSettings');
    },

    /**
     * sets the shipment directly, used when 4 shipments a year is selected
     * @param dispatch
     * @param commit
     * @param shipments
     */
    setShipments({dispatch, commit}, shipments) {
        commit('updateShipments', shipments);
        dispatch('changeShipmentSettings');
    },

    /**
     * clears all selected shipments
     * @param commit
     * @param dispatch
     */
    clearShipments({dispatch, commit}) {
        commit('updateShipments', []);
        dispatch('changeShipmentSettings');
    },

    /**
     * when member tier and shipments change, the shipment multiplier and minimum limit changes
     * @param dispatch
     * @param commit
     */
    changeShipmentSettings({dispatch, commit}) {
        if (state.memberTier && state.shipments) {
            let annualBottles = state.memberTier.AnnuallyBottles > 12 ? state.memberTier.AnnuallyBottles : 12,
                shipmentCount = state.shipments.length;
            if (annualBottles > 0 && shipmentCount > 0) {
                let min = annualBottles / shipmentCount;
                dispatch('changeShipmentMinimum', min);
            }
        }
    },

    /**
     * update the shipment's minimum value
     * @param dispatch
     * @param commit
     * @param min
     */
    changeShipmentMinimum({dispatch, commit}, min) {
        commit('updateShipmentMinimum', min);
        let activeCatalog = state.activeCatalog;

        if (activeCatalog) {
            dispatch('useCatalogWine', activeCatalog);
        }

        let selection = state.shipmentWines;

        if (selection === null) {
            selection = []
        }

        if (selection && selection.length !== min) {
            let diff = min - selection.length;
            if (diff > 0) {
                for (let i = 0; i < diff; i++) {
                    selection.push({});
                }
            }
            // else {   //this may not be needed because flexi members will have wine greater than what the member tier says
            //     for (let i = 0; i < Math.abs(diff); i++) {
            //         selection.pop();
            //     }
            // }
            commit('updateShipmentWines', selection);
        }
    },

    /**
     * add cheese to shipment
     * @param dispatch
     * @param commit
     * @param catalog
     */
    useCatalogCheese({dispatch, commit}, catalog) {
        commit('updateActiveCheeseAddon', catalog);

        let data = new FormData(),
            catalogID = catalog ? catalog.ID : 0;
        data.append('MemberID', state.memberID);
        data.append('CheeseCatalog', catalogID);
        dispatch('changeAddon', data);
    },

    /**
     * populate the shipment from a chosen catalog of wines
     * @param dispatch
     * @param commit
     * @param catalog
     */
    useCatalogWine({dispatch, commit}, catalog) {
        // console.log(state.shipmentMinimum)
        const wines = catalog.Wines;

        // console.log('use catalog wine being called')
        if (!wines || wines.length === 0) {
            state.shipmentWines = null
            commit('updateActiveCatalog', null);
        } else {
            state.shipmentWines = catalog.Wines
            commit('updateActiveCatalog', catalog);
        }


        // dispatch('emptyShipment');

        // if (wines && wines.length) {
        //     let min = state.shipmentMinimum;

        //     // fill the shipment with wines from this catalog
        //     while (min >= wines.length) {
        //         wines.forEach(wine => {
        //             dispatch('addShipmentWine', wine);
        //         });

        //         min -= wines.length;
        //     }

        //     // keep filling if there are remainders
        //     for (let i = 0; i < min; i++) {
        //         dispatch('addShipmentWine', wines[i]);
        //     }

        //     commit('updateActiveCatalog', catalog);
        //     commit('updateIsCustomSelection', false);
        // } else {
        //     commit('updateActiveCatalog', null);
        //     commit('updateIsCustomSelection', true);
        // }

        // dispatch('calculateShipmentPrices');
    },

    setShippingWineList({commit}, wineList) {
        state.shipmentWines = wineList
        commit('updateActiveCatalog', null);
    },

    /**
     * populate the shipment from preference wines
     * @param dispatch
     * @param commit
     * @param preference
     */
    usePreferenceWine({dispatch, commit}, preference) {
        let wines = preference.Wines;
        dispatch('emptyShipment');

        let catalog = preference.Catalog;
        if (catalog.ID > 0) {
            if (wines.length) {
                wines.forEach(item => {
                    dispatch('addShipmentWine', item);
                });
            }
        } else if (state.selections.length) {
            // if preference is a custom selection the wines saved might have been disabled from wine club so have to verify against current selections.
            let lookupWines = [];
            state.selections.forEach(item => {
                lookupWines = [...lookupWines, ...item.Wines]
            });
            let validSelections = wines.filter(a => lookupWines.some(b => a.ID === b.ID));
            if (validSelections.length) {
                validSelections.forEach(item => {
                    dispatch('addShipmentWine', item);
                });
            }
        }

        dispatch('calculateShipmentPrices');
    },

    /**
     * empty the shipment and start again
     * @param commit
     */
    emptyShipment({dispatch, commit}) {
        let selection = [],
            min = state.shipmentMinimum;
        for (let i = 0; i < min; i++) {
            selection.push({});
        }
        commit('updateShipmentWines', selection);
        commit('updateActiveCatalog', null);
        dispatch('calculateShipmentPrices');
    },

    /**
     * handles adding a wine to the shipment
     * @param dispatch
     * @param commit
     * @param wine
     */
    addShipmentWine({dispatch, commit}, wine) {
        let selection = state.shipmentWines,
            placeholder = selection.findIndex((item) => {
                return typeof item.ID === 'undefined'
            });

        if (wine.ID && placeholder >= 0) {
            selection.splice(placeholder, 1, wine);
        } else {
            selection.push(wine);
        }

        commit('updateShipmentWines', selection);
        commit('updateActiveCatalog', null);
        dispatch('calculateShipmentPrices');
    },

    /**
     * handles remove a wine or index of a wine from the shipment
     * @param dispatch
     * @param commit
     * @param index
     */
    removeShipmentWine({dispatch, commit}, index) {
        let selection = state.shipmentWines;

        // this function can remove by object or remove by index
        if (typeof index === 'object') {
            index = selection.findIndex(m => m.ID === index.ID);
        }

        selection.splice(index, 1);

        // // minimum shipment size is 3 bottles of wine.
        // let min = state.shipmentMinimum;
        // if (selection.length < min) {
        //     let missing = min - selection.length;
        //     for (let i = 0; i < missing; i++) {
        //         selection.push({});
        //     }
        // }
        commit('updateShipmentWines', selection);
        commit('updateActiveCatalog', null);
        dispatch('calculateShipmentPrices');
    },

    removeActiveCatalog({}) {
        state.activeCatalog = null
    },

    /**
     * find the discount percentage for member
     * @param commit
     * @returns {number}
     */
    findDiscount({commit}) {
        let selection = state.shipmentWines.filter(m => typeof m.ID !== 'undefined'),
            shipments = state.shipments,
            memberTier = state.memberTier,
            annualBottleCount = memberTier.AnnuallyBottles > 0 ? memberTier.AnnuallyBottles : selection.length * shipments.length,
            discount = state.discounts.find(m => m.MemberTier.ID === memberTier.ID);

        if (typeof discount === 'undefined' && annualBottleCount > 0) {
            discount = state.discounts.filter(m => {
                return annualBottleCount >= m.MemberTier.AnnuallyBottles;
            });
        }

        let mostQualifiedDiscount = 0;
        if (discount.length) {
            mostQualifiedDiscount = Math.max.apply(Math, discount.map(m => m.Percent));
        } else if (typeof discount.Percent !== 'undefined') {
            mostQualifiedDiscount = discount.Percent;
        }

        commit('updateEligibleDiscount', mostQualifiedDiscount);
    },

    /**
     * recalculate the original price, discounted price and total savings when ever a wine is added or removed from shipment
     * @param dispatch
     * @param commit
     */
    calculateShipmentPrices({dispatch, commit}) {
        let selection = state.shipmentWines.filter(m => typeof m.ID !== 'undefined'),
            pricesArray = selection.map(item => item.LocalisedPrice),
            activeCatalog = state.activeCatalog;

        if (pricesArray.length) {
            let sumValues = selection.map(item => item.LocalisedPrice).reduce((a, b) => a + b);
            commit('updateOriginalPrice', sumValues.toFixed(2));

            if (activeCatalog) {
                commit('updateDiscountedPrice', activeCatalog.Price.toFixed(2));
                let discount = sumValues - activeCatalog.Price;
                commit('updateSavings', discount.toFixed(2));
            } else {
                dispatch('findDiscount');
                let mostQualifiedDiscount = state.eligibleDiscount,
                    savings = sumValues * mostQualifiedDiscount;
                commit('updateSavings', savings.toFixed(2));

                let discountedPrice = sumValues - savings;
                commit('updateDiscountedPrice', discountedPrice.toFixed(2));
            }
        } else {
            commit('updateOriginalPrice', 0.00);
            commit('updateDiscountedPrice', 0.00);
            commit('updateSavings', 0.00);
        }
    },

    /**
     * Updates preference for existing member. If MemberID in the data is 0 or null,
     * saves to cookie and redirects to the register page.
     *
     * @param {function} commit - The commit function.
     * @param {Object} data - The data object containing member preferences.
     * @param {number} [data.MemberID=0] - The ID of the member.
     * @param {number} [data.MemberTier=0] - The tier ID of the member.
     * @param {number} [data.Catalog=0] - The catalog ID.
     * @param {string} [data.Shipments] - A comma-separated string of shipment IDs.
     * @param {string} [data.Wines] - A comma-separated string of wine IDs.
     * @returns {Promise<void>}
     */
    async changePreference({commit}, data) {
        commit('updatePreferenceErrorMessage', null);
        const response = await axios.post(window.location.origin + '/account/changePreference', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data !== 'undefined') {

            const response = await axios.post(window.location.origin + '/account/memberData', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
            if (typeof response.data !== 'undefined') {
                commit('updateMemberData', response.data);
            }

            if (response.data.Redirect) {
                // window.location = response.data.Redirect;
            } else if (response.data.Message) {
                commit('updatePreferenceErrorMessage', response.data.Message);
            }
        }
    },

    async getMemberData({commit}, data) {
        const response = await axios.post(window.location.origin + '/account/memberData', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data !== 'undefined') {
            commit('updateMemberData', response.data);
        }
    },

    setActiveCatalog({commit}, catalog) {
        commit('updateActiveCatalog', catalog);
    },


    /**
     * updates addons to existing preference
     * @param commit
     * @param data
     * @returns {Promise<void>}
     */
    async changeAddon({commit}, data) {
        const response = await axios.post(window.location.origin + '/account/changeAddon', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data !== 'undefined') {
            if (response.data.Redirect) {
                window.location = response.data.Redirect;
            }
        }
    }



    // setMember({commit}, memberID) {
    //     commit('updateMemberID', memberID);
    // },
    //
    // // async registerUser({commit}, data) {
    //     commit('updateFormError', null);
    //     const response = await axios.post(window.location.origin + '/account/register', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
    //     if (typeof response.data !== 'undefined') {
    //         commit('updateFormError', response.data.message ? response.data.message : null);
    //         commit('updateMemberID', response.data.member ? response.data.member.ID : null);
    //         if (response.data.code === 1 && response.data.redirect) {
    //             window.location = response.data.redirect;
    //         }
    //     }
    // },
    //
    // async loginUser({dispatch, commit}, data) {
    //     commit('updateFormError', null);
    //     const response = await axios.post(window.location.origin + '/account/login', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
    //     if (typeof response.data !== 'undefined') {
    //         commit('updateFormError', response.data.message ? response.data.message : null);
    //         commit('updateMemberID', response.data.member ? response.data.member.ID : null);
    //         if (response.data.code === 1) {
    //             commit('updateConfigStep', 5);
    //         } else if (response.data.code === 3) {
    //             commit('updateShipmentCountry', response.data.country ? response.data.country : 'nz');
    //         } else {
    //             commit('updateLoginStatusCode', response.data.code);
    //         }
    //     }
    // },
};

const mutations = {
    updateClubData: (state, value) => (state.clubData = value),
    updateCountryData: (state, data) => {
        state.availableShipments = data.Schedules
        state.catalogs = data.Catalogs
        state.selections = data.Selections
        state.discounts = data.Discounts
        state.currency = data.Currency
    },
    updateShipmentCountry: (state, value) => (state.shipmentCountry = value),
    updateAvailableShipments: (state, value) => (state.availableShipments = value),
    updateCatalogs: (state, value) => (state.catalogs = value),
    updateCheeseCatalogs: (state, value) => (state.cheeseCatalogs = value),
    updateSelections: (state, value) => (state.selections = value),
    updateDiscounts: (state, value) => (state.discounts = value),
    updateShipments: (state, value) => (state.shipments = value),
    updateMemberData: (state, data) => {
        state.memberID = data.MemberID;
        state.memberFirstName = data.MemberFirstName;
        state.memberSurname = data.MemberSurname;
        state.memberCountry = data.MemberCountry;
        state.memberStatus = data.MemberStatus;
        state.nextShipmentDate = data.NextShipment;
        state.memberTier = data.MemberTier;
        state.isClubMember = data.IsClubMember;
        state.isNextShipmentOpen = data.ShipmentOpen;
        state.isLoggedIn = true;

        state.shippingAddressID = data.ShippingAddressID;
        state.shippingAddress = data.ShippingAddress;
        state.savedCardID = data.SavedCardID;
    },
    updateMemberID: (state, value) => (state.memberID = value),
    updateMemberFirstName: (state, value) => (state.memberFirstName = value),
    updateMemberSurname: (state, value) => (state.memberSurname = value),
    updateMemberCountry: (state, value) => (state.memberCountry = value),
    updateExistingPreference: (state, value) => (state.existingPreference = value),
    updateMemberTier: (state, value) => (state.memberTier = value),
    updateNextShipmentDate: (state, value) => (state.nextShipmentDate = value),
    updateConfigStep: (state, value) => (state.configStep = value),
    updateIsCustomSelection: (state, value) => (state.isCustomSelection = value),
    updateActiveCatalog: (state, value) => (state.activeCatalog = value),
    updateActiveCheeseAddon: (state, value) => (state.activeCheeseAddon = value),
    updateShipmentWines: (state, value) => (state.shipmentWines = value),
    updateShipmentMinimum: (state, value) => (state.shipmentMinimum = value),
    updateOriginalPrice: (state, value) => (state.originalPrice = value),
    updateDiscountedPrice: (state, value) => (state.discountedPrice = value),
    updateEligibleDiscount: (state, value) => (state.eligibleDiscount = value),
    updateSavings: (state, value) => (state.savings = value),
    updateIsLoggedIn: (state, value) => (state.isLoggedIn = value),
    updateIsClubMember: (state, value) => (state.isClubMember = value),
    updateHasPreference: (state, value) => (state.hasPreference = value),
    updateIsNextShipmentOpen: (state, value) => (state.isNextShipmentOpen = value),
    updateShippingAddressID: (state, value) => (state.shippingAddressID = value),
    updateShippingAddress: (state, value) => (state.shippingAddress = value),
    updateSavedCardID: (state, value) => (state.savedCardID = value),
    updatePreferenceErrorMessage: (state, value) => (state.preferenceErrorMessage = value),
    updateMinAllowedShipments: (state, value) => (state.minAllowedShipments = value),
    updateOrderHistory: (state, value) => (state.orderHistory = value),
    updateCurrency: (state, value) => (state.currency = value),
};

export default {
    state,
    getters,
    actions,
    mutations
};
